import { EventPlugin } from '@absis/core-plugins';

export const CBEvent: EventPlugin = {
  sendLogEvent(): void {
    throw new Error('CBEvent is not supported in web applications');
  },
  sendBusinessEvent(): void {
    throw new Error('CBEvent is not supported in web applications');
  },
  addListener(): void {
    throw new Error('CBEvent is not supported in web applications');
  },
  // removeAllListeners(): void {
  //   throw new Error('CBEvent is not supported in web applications');
  // },
};

export const CBStorage = CBEvent;
